import React from 'react'
import {  Table } from 'reactstrap';
import File from 'react-icons/lib/md/insert-drive-file'

export default class ProfileEquipments extends React.Component {


	truncateUrl(url){
		if(url){
			var arr = url.split('media');
			//return "https://pro.homeserve.fr/media"+arr.slice(-1)[0]
      return process.env.REACT_APP_URL_DOCUMENT+arr.slice(-1)[0]
		}
	}

	render(){
		const{ provider } = this.props;
		return(
			<div className="provider-profile-bloc"> 
	            <Table className="table-document">
	                <tbody>
	                      <tr className="first">
	                        <td>
	                            <div className="title-bloc">
	                                Documents
	                            </div>
	                        </td>
	                        <td>
	                            Télécharger
	                        </td>
	                      </tr>

                        {provider.contract &&
                            <tr>
                                <td>
                                   Contrat
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"><a
                                        href={this.truncateUrl(provider.contract)} target="_blank"
                                        rel="noopener noreferrer"> <File size="24"/> Télécharger</a></div>
                                </td>
                            </tr>
                        }
                        {provider.kbis &&
                            <tr>
                                <td>
                                   Kbis
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.kbis)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.rcp &&
                            <tr>
                                <td>
                                   Responsabilité civile Pro
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.rcp)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.info_sheet &&
                            <tr>
                                <td>
                                    Fiche de renseignement
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"><a
                                        href={this.truncateUrl(provider.info_sheet)} target="_blank"
                                        rel="noopener noreferrer"> <File size="24"/> Télécharger</a></div>
                                </td>
                            </tr>
                        }
                        {provider.price &&
                            <tr>
                                <td>
                                   Bordereau de prix négocié avec HomeServe
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.price)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.result &&
                            <tr>
                                <td>
                                   Bilan et compte de résultat
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.result)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.urssaf &&
                            <tr>
                                <td>
                                   Attestation URSSAF
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.urssaf)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.mappoint &&
                            <tr>
                                <td>
                                   Carte Mappoint
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.mappoint)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.rib &&
                            <tr>
                                <td>
                                   RIB
                                </td>
                                <td>
                                    <div className="table-document-active item-doc"> <a href={this.truncateUrl(provider.rib)} target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div>
                                </td>
                            </tr>
                        }
                        {provider.free_text &&
                        <tr>
                            <td>
                                Informations complémentaires
                            </td>
                            <td>
                                <div className="text">{provider.free_text}</div>
                            </td>
                        </tr>
                        }
	                </tbody>
	            </Table>
	        </div>
		)

	}
}


// WEBPACK FOOTER //
// ./src/provider/components/profile/ProfileDocuments.js